import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlashFilledIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { Popover } from "@air/primitive-popover";
import { memo } from "react";
import { useAssetModalTheme } from "~/components/AssetModalV2/AssetModalThemeContextProvider";
import { INTELLIGENCE_UPSELL_MESSAGE } from "~/constants/upsells";
export const EnrichmentUpsellButton = /*#__PURE__*/ memo((param)=>{
    let { onUpgrade } = param;
    const { theme } = useAssetModalTheme();
    return /*#__PURE__*/ _jsx(Popover, {
        side: "top",
        align: "start",
        "data-theme": theme,
        className: "max-w-xs border-0",
        trigger: /*#__PURE__*/ _jsx(Button, {
            appearance: "filled",
            color: "grey",
            size: "small",
            className: "mt-2",
            prefix: /*#__PURE__*/ _jsx(FlashFilledIcon, {
                className: "size-3 text-blue-9"
            }),
            children: "View more"
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center gap-3 p-2",
            children: [
                /*#__PURE__*/ _jsx(FlashFilledIcon, {
                    className: "size-6 text-blue-9"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-12 text-grey-12",
                    children: [
                        INTELLIGENCE_UPSELL_MESSAGE,
                        " ",
                        /*#__PURE__*/ _jsx("button", {
                            onClick: onUpgrade,
                            className: "cursor-pointer underline",
                            children: "Click to upgrade."
                        })
                    ]
                })
            ]
        })
    });
});
EnrichmentUpsellButton.displayName = "EnrichmentUpsellButton";
